import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledFilterBar = styled.div`
  /* fix for pill outline */
  button {
    margin: ${toRem(2)} 0;
  }
`;
